import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'

import { CustomerRegistration } from '@js/api/types/customer/CustomerRegistration'

interface GetCustomerRegistrationResponse {
  data: {
    getCustomerRegistrationById: CustomerRegistration
  }
  errors?: [{ message: string }]
}

export const customerRegistrationQuery = gql`
  query($registrationId: Int!) {
    getCustomerRegistrationById(registration_id: $registrationId) {
      registration_id
      craft_entry_id
      personal {
        country
        address
        postcode
        state
        address_two
        city
        phone
        secondary_phone
      }
      professional {
        licenses {
          license_id
          license_number
          license_type
          license_state
        }
        management_level
        primary_employment
        employer_name
        employer_city
        employer_state
        hear_about
        certifications
      }
      item {
        course_option
        sku
      }
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const getCustomerRegistration = async (payload: { registrationId: number }): Promise<CustomerRegistration> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerRegistrationResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: customerRegistrationQuery,
      variables: {
        registrationId: payload.registrationId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.getCustomerRegistrationById
}
